
import {
  ConifgResult,
  KeyenceModule,
  isKeyenceEnterpriseBrowser,
  ConfigId,
  isBulkReadableHT,
  isHandsFreeSupportedHT,
} from '@/utils/keyenceHT/keyenceModules'
import { Vue } from 'vue-class-component'
import { LOCAL_STORAGE_ITEM } from '@/utils/constants'
import { Prop } from 'vue-property-decorator'

export default class ScannerConfig extends Vue {
  @Prop({ type: String }) scannerConfigName?: string = 'ScannerConfig'
  @Prop({ type: Boolean }) shouldBulkMode?: boolean = false
  aimerTarget = 'CENTER'
  aimerTargetStorageKey = `${LOCAL_STORAGE_ITEM.KEYENCE_SCANNER_CONFIG_AIMER_TARGET}-on-${this.scannerConfigName || ''}`
  isExpanding = false
  isExpandingStorageKey = `${LOCAL_STORAGE_ITEM.KEYENCE_SCANNER_CONFIG_ISEXPANDING}-on-${this.scannerConfigName || ''}`
  aimerTargetOptions = [
    { label: 'keyenceModule.scanConfig.aimerTarget.center', value: 'CENTER' },
    { label: 'keyenceModule.scanConfig.aimerTarget.horizontal', value: 'HORIZONTAL_LINE' },
    { label: 'keyenceModule.scanConfig.aimerTarget.firstDetected', value: 'DISABLE' },
  ] as LabelOption[]

  get isEnterpriseBrowser() {
    return isKeyenceEnterpriseBrowser()
  }

  async mounted() {
    this.loadSelectionFromLocalStorage()
    this.setOption()
  }

  onOptionChange() {
    this.setOption()
  }

  setOption() {
    if (!this.isEnterpriseBrowser || !KeyenceModule?.Scanner) {
      return
    }

    const scanParams = KeyenceModule.Scanner.getConfig(ConfigId.ScanParams) as ScanParams | null
    if (!scanParams?.target || !scanParams.trigger) {
      return
    }

    scanParams.target.aimerTarget = this.aimerTarget
    this.applyBulkScanSettings(scanParams)

    const configResult = KeyenceModule.Scanner.setConfig(ConfigId.ScanParams, scanParams)
    if (configResult !== ConifgResult.Succeeded) {
      return
    }

    this.saveSelectionToLocalStorage()
  }

  applyBulkScanSettings(scanParams: ScanParams) {
    if (this.shouldBulkMode && isBulkReadableHT) {
      if (isHandsFreeSupportedHT) {
        scanParams.trigger.triggerMode = 'HANDS_FREE'
      }
      if (scanParams.collection) {
        scanParams.collection.method = 'ACCUMULATE'
      }
      return
    }

    scanParams.trigger.triggerMode = 'NORMAL'
    if (scanParams.collection) {
      scanParams.collection.method = 'SINGLE'
    }
  }

  handleExpanding() {
    this.isExpanding = !this.isExpanding
    this.saveSelectionToLocalStorage()
  }

  saveSelectionToLocalStorage() {
    localStorage.setItem(this.aimerTargetStorageKey, this.aimerTarget)
    localStorage.setItem(this.isExpandingStorageKey, this.isExpanding.toString())
  }

  loadSelectionFromLocalStorage() {
    const savedIsExpanding = localStorage.getItem(this.isExpandingStorageKey)
    this.isExpanding = savedIsExpanding === 'true'
    const savedAimerTarget = localStorage.getItem(this.aimerTargetStorageKey)
    this.aimerTarget = savedAimerTarget || this.aimerTargetOptions[0].value
  }
}

type LabelOption = {
  label: string
  value: string
}

type ScanParams = {
  target: {
    aimerTarget: string
  }
  trigger: {
    triggerMode: string
  }
  collection?: {
    method: string
  }
}
